import { render, staticRenderFns } from "./WorkerCombobox.vue?vue&type=template&id=6d1b28e2&scoped=true"
import script from "./WorkerCombobox.vue?vue&type=script&lang=js"
export * from "./WorkerCombobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1b28e2",
  null
  
)

export default component.exports